import { useAppSelector } from '@/app/hooks';
import { selectCurrentUser } from '@/slices/auth/constants/sessionSelectors';

// The signed-in user view model `{ id, name, email, avatarUrl }`, or null.
export const useCurrentUser = () => {
  return useAppSelector(selectCurrentUser);
};
